// extracted by mini-css-extract-plugin
export default {"tooltip":"Dropdown_tooltip__uavSB","tooltiptext":"Dropdown_tooltiptext__nR4WE","dropdown":"Dropdown_dropdown__QEFz6"};